import {
  useCorporateTopUnderwritersContext,
} from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/CorporateTopUnderwritersContext';
import { UNDERWRITER_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';
import CorporateTable
  from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesTables/CorporateTables/CorporateTable';

const CorporateTopUnderwriters = () => {
  const { data, loading, page, paginate } = useCorporateTopUnderwritersContext();

  return (
    <CorporateTable
      data={ data }
      loading={ loading }
      page={ page }
      paginate={ paginate }
      companyRole={ UNDERWRITER_NAME }
      emptyMessageText="No underwriters during the selected period."
    />
  );
};

export default CorporateTopUnderwriters;
